import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Experience } from '../types/Experience';
import * as Icons from 'lucide-react';
interface ExperienceBubbleProps {
  experience: Experience;
  isSelected: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
}
export function ExperienceBubble({
  experience,
  isSelected,
  onClick,
  style
}: ExperienceBubbleProps) {
  const handleClick = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
    onClick();
  };
  // Get the icon component dynamically, fallback to Wine if not found
  const IconComponent = experience.icon ? (Icons as any)[experience.icon] || Icons.Wine : Icons.Wine;
  const isLocked = experience.locked;
  // Colors for bubbles with wines (unlocked): bordeaux background, white text/tag
  // Colors for locked bubbles: gray background, gray text/tag
  const backgroundColor = isLocked ? '#FFFFFF' : '#6C083B';
  const borderColor = isLocked ? '#D7D7D7' : '#6C083B';
  const iconColor = isLocked ? '#999999' : '#FFFFFF';
  const textColor = isLocked ? '#999999' : '#FFFFFF';
  const tagBgColor = isLocked ? '#D7D7D7' : '#FFFFFF';
  const tagTextColor = isLocked ? '#FFFFFF' : '#6C083B';
  // Format bottle count text
  const bottleText = experience.bottleCount === 1 ? 'vino' : 'vini';
  return <motion.button className="absolute overflow-hidden cursor-pointer" style={{
    ...style,
    width: 110,
    height: 110,
    borderRadius: '50%',
    backgroundColor: backgroundColor,
    border: `1px solid ${borderColor}`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    userSelect: 'none',
    WebkitUserSelect: 'none'
  }} onClick={handleClick} onTouchEnd={handleClick} whileHover={{
    y: -4
  }} animate={{
    scale: isSelected ? 1.05 : 1,
    boxShadow: isSelected ? '0 8px 24px rgba(108, 8, 59, 0.25)' : '0 2px 8px rgba(0, 0, 0, 0.08)'
  }} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 25
  }} aria-label={`${experience.name}, ${experience.bottleCount} ${bottleText}, ${experience.locked ? 'bloccata' : 'sbloccata'}`} data-id="element-44">
      {/* Main Content - Centered */}
      <div className="flex flex-col items-center justify-center px-3 py-3 h-full gap-1" data-id="element-45">
        {/* Icon */}
        <IconComponent size={24} style={{
        color: iconColor
      }} strokeWidth={1.5} data-id="element-46" />

        {/* Name - Non-selectable */}
        <div className="text-center font-medium w-full" style={{
        fontSize: '9px',
        lineHeight: '1.1',
        color: textColor,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        userSelect: 'none',
        WebkitUserSelect: 'none'
      }} data-id="element-47">
          {experience.name}
        </div>

        {/* Bottle Count Tag - Non-selectable */}
        <div className="font-semibold" style={{
        backgroundColor: tagBgColor,
        color: tagTextColor,
        fontSize: '8px',
        padding: '2px 6px',
        borderRadius: '8px',
        userSelect: 'none',
        WebkitUserSelect: 'none'
      }} data-id="element-48">
          {experience.bottleCount} {bottleText}
        </div>
      </div>
    </motion.button>;
}